import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import getNumberOfLayers from "../../../../service/getNumberOfLayers"
import type EstimateValues from "../../../../types/params"

const replaceEmcShield = (values: EstimateValues) => {
  const isDisplayed = getDisplayCondition(values)
  const numberOfLayers = getNumberOfLayers(values)

  if (isDisplayed.emcShield) {
    switch (values.emcShield) {
      case ESTIMATE_CONSTANT.電磁波シールド["両面貼る(片面)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["両面貼る(2層)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["両面貼る(3層)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["両面貼る(4層)"].value:
        if (numberOfLayers === 1) return ESTIMATE_CONSTANT.電磁波シールド["両面貼る(片面)"].value
        if (numberOfLayers === 2) return ESTIMATE_CONSTANT.電磁波シールド["両面貼る(2層)"].value
        if (numberOfLayers === 3) return ESTIMATE_CONSTANT.電磁波シールド["両面貼る(3層)"].value
        if (numberOfLayers === 4) return ESTIMATE_CONSTANT.電磁波シールド["両面貼る(4層)"].value
        break

      case ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(片面)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(2層)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(3層)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(4層)"].value:
        if (numberOfLayers === 1)
          return ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(片面)"].value
        if (numberOfLayers === 2)
          return ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(2層)"].value
        if (numberOfLayers === 3)
          return ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(3層)"].value
        if (numberOfLayers === 4)
          return ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(4層)"].value
        break

      case ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(片面)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(2層)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(3層)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(4層)"].value:
        if (numberOfLayers === 1)
          return ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(片面)"].value
        if (numberOfLayers === 2)
          return ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(2層)"].value
        if (numberOfLayers === 3)
          return ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(3層)"].value
        if (numberOfLayers === 4)
          return ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(4層)"].value
        break

      case ESTIMATE_CONSTANT.電磁波シールド["貼らない(片面)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["貼らない(2層)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["貼らない(3層)"].value:
      case ESTIMATE_CONSTANT.電磁波シールド["貼らない(4層)"].value:
        if (numberOfLayers === 1) return ESTIMATE_CONSTANT.電磁波シールド["貼らない(片面)"].value
        if (numberOfLayers === 2) return ESTIMATE_CONSTANT.電磁波シールド["貼らない(2層)"].value
        if (numberOfLayers === 3) return ESTIMATE_CONSTANT.電磁波シールド["貼らない(3層)"].value
        if (numberOfLayers === 4) return ESTIMATE_CONSTANT.電磁波シールド["貼らない(4層)"].value
        break
    }
  }

  return values.emcShield
}

export default replaceEmcShield
